import { useSelector } from "react-redux";

const NewsDisplay1 = () => {
  const { selectedFuelEuData } = useSelector((state) => state.newsroom);

  if (!selectedFuelEuData) {
    return (
      <div className="nm-display-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', minHeight: '300px' }}>
        <p>Select a FuelEU update to read</p>
      </div>
    );
  }

  const publishDate = selectedFuelEuData?.publish_date
    ? new Date(selectedFuelEuData.publish_date).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })
    : '';

  const sectionData = selectedFuelEuData?.section_data;
  const isObjectData = sectionData && typeof sectionData === 'object' && !Array.isArray(sectionData);

  const formatLabel = (key) => {
    return key
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const SECTION_ORDER = [
  'CARBON PRICE',
  'BEHAVIOR AND SPECULATION',
  'ENERGY MIX',
  'AZOLLA VIEW',
];

  return (
    <div className="nm-display-wrapper">
      {/* Article header */}
      <div style={{ marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: '1px solid #e2e8f0' }}>
        <div style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '0.5rem' }}>
          {publishDate}
        </div>
        <h1 style={{ fontSize: '1.35rem', fontWeight: '700', color: '#0f172a', lineHeight: '1.4', marginBottom: '0.5rem' }}>
          {selectedFuelEuData?.title}
        </h1>
        {selectedFuelEuData?.publish_by && (
          <div style={{ fontSize: '0.82rem', color: '#64748b' }}>Published by <strong>{selectedFuelEuData.publish_by}</strong></div>
        )}
      </div>

      {/* Thumbnail */}
      {selectedFuelEuData?.thumbnail_url && (
        <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: '1px solid #e2e8f0' }}>
          <img
            className="newsroom-thumbnail"
            src={selectedFuelEuData.thumbnail_url}
            alt="fueleu analysis"
          />
        </div>
      )}

      {/* Structured sections */}
      {isObjectData ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
          {/* Key Metrics Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '0.5rem' }}>
            {['avg_surplus_price', 'bid_ask_spread', 'pooling_deadline', 'banking_deadline'].map((key) => (
              sectionData[key] && (
                <div
                  key={key}
                  style={{ paddingBottom: '1rem', borderBottom: '1px solid #e2e8f0' }}
                >
                  <div style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f172a', marginBottom: '0.5rem' }}>
                    {formatLabel(key)}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#475569' }}>
                    {key === 'avg_surplus_price' ? `€${sectionData[key]}` : sectionData[key]}
                  </div>
                </div>
              )
            ))}
          </div>

          {/* Content Sections */}
        {SECTION_ORDER.map((key) => {
  const value = sectionData[key];

  // Don't display sections that are not present in the API response
  if (!value) return null;

  return (
    <div
      key={key}
      style={{
        paddingBottom: '1rem',
        borderBottom: '1px solid #e2e8f0'
      }}
    >
      <div
        style={{
          fontSize: '0.95rem',
          fontWeight: '700',
          color: '#0f172a',
          marginBottom: '0.5rem'
        }}
      >
        {formatLabel(key)}
      </div>

      <div
        style={{
          fontSize: '0.85rem',
          color: '#475569',
          lineHeight: '1.7'
        }}
      >
        {value}
      </div>
    </div>
  );
})}
        </div>
      ) : (
        <div style={{ paddingBottom: '1rem', borderBottom: '1px solid #e2e8f0', fontSize: '0.85rem', color: '#475569', lineHeight: '1.75', whiteSpace: 'pre-line' }}>
          {selectedFuelEuData?.description}
        </div>
      )}
    </div>
  );
};

export default NewsDisplay1;
